import { Color, transientOptions } from '@billy/design-system'
import styled from '@emotion/styled'

export const EmptyStateFrame = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border: var(--lumen-border-width-xs) solid var(--lumen-color-border-neutral-soft);
  border-radius: var(--lumen-border-radius-8);
  background-color: ${Color.White};
  overflow: hidden;
`

export const HeaderScroll = styled.div`
  flex-shrink: 0;
  width: 100%;
  overflow-x: auto;
`

interface HeaderTableProps {
  $minWidth: `${number}px`
}

export const HeaderTable = styled('table', transientOptions)<HeaderTableProps>`
  width: 100%;
  min-width: ${({ $minWidth }) => $minWidth};
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
`

export const EmptyStateBody = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  min-height: 0;
`
